import i18n from '@/i18n';

const RELATED_MODULE_COUNT_FIELDS = [
  {
    key: 'checklists_count',
    text: '張點檢表',
  },
  {
    key: 'acts_count',
    text: '部法規',
  },
  {
    key: 'audits_count',
    text: '張稽核表',
  },
  {
    key: 'changes_count',
    text: '個變動計畫',
  },
  {
    key: 'change_versions_count',
    text: '個變動計畫',
  },
  {
    key: 'contractor_enter_records_count',
    text: '個承攬商進場記錄',
  },
  {
    key: 'contractor_licenses_count',
    text: '張承攬商資格證',
  },
  {
    key: 'contractors_count',
    text: '家承攬商',
  },
  {
    key: 'contracts_count',
    text: '份承攬商契約',
  },
  {
    key: 'events_count',
    text: '個風險事件',
  },
  {
    key: 'internal_trainings_count',
    text: '個教育訓練',
  },
  {
    key: 'licenses_count',
    text: '張證照',
  },
  {
    key: 'qrcodes_count',
    text: '個QRcode',
  },
  {
    key: 'tasks_count',
    text: '個任務',
  },
  {
    key: 'task_factory_templates_count',
    text: '個任務範本',
  },
  {
    key: 'meetings_count',
    text: '場議事',
  },
  {
    key: 'meeting_templates_count',
    text: '個議事範本',
  },
  {
    key: 'guidelines_count',
    text: '部內規',
  },
  {
    key: 'guideline_article_versions_count',
    text: '條條文',
  },
];

function setRelatedModuleNumList(rawData) {
  return RELATED_MODULE_COUNT_FIELDS.reduce((relatedModuleNumList, field) => {
    if (rawData[field.key]) relatedModuleNumList.push(i18n.t(`{number}${field.text}`, {number: rawData[field.key]}));
    return relatedModuleNumList;
  }, []);
}

export default {
  setDeleteInfo(rawData, inUseContentText) {
    const relatedModuleNumList = setRelatedModuleNumList(rawData);
    return {
      contentText: relatedModuleNumList.length
        ? inUseContentText
        : '',
      relatedModuleNumList,
    };
  },
}
